import React from 'react'
import Typography from '@mui/material/Typography';
import { Box, Grid2 as Grid, Tooltip } from '@mui/material';
import { globalstyles as styles } from '../lib/definitions';

export const category_section = {
    1:1,
    2:1,
    3:1,
    4:1,
    5:1,
    6:1,
    7:2,
    8:3,
    9:3,
    10:3,
    11:3,
    12:3,
    13:4,
    14:4,
    15:4,
    16:4,
}


export const CategoryLabel = (props) => {
    const element = props.element
    return (
        <Tooltip title={
                element?.category_description
        }>
            <Box
                sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '12px'
                }}>
                {element?.category_name}
            </Box>

        </Tooltip>
    )

}



export const CategoryButton = (props) => {
    const element = props.element
    return (
        <>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    position: 'relative',
                    lineHeight:'14px',
                    fontSize: '12px'
                }}>
                {element?.category_name}
            </Typography>
            <Typography
                component="div"
                variant="subtitle2"
                color="inherit"
                sx={{
                    position: 'relative',
                    fontSize: '11px',
                    lineHeight:'12px',
                    textTransform: 'none'
                }}>
                {element?.category_description}
            </Typography>
        </>
    )

}



export const CategoryRow = (props) => {

    const element = props.element
    const fontSize = props.fontSize || '10px'
    return (
        <Grid container >
            <Grid size="grow" sx={{ fontSize: fontSize, fontWeight: 'bold' }}>
                {element.category_name}
            </Grid>
            <Grid size={"grow"} sx={{ fontSize: fontSize, color: 'blue' }}>
                {element.category_description}
            </Grid>
            <Grid size="auto" sx={{ fontSize: fontSize }}>
            </Grid>

        </Grid>
    )

}
export const CategoryHeader = () => (
    <Grid container >
        <Grid item size="grow" sx={styles.listHeader}>
            Nome
        </Grid>
        <Grid item size="grow" sx={styles.listHeader}>
            Descrizione
        </Grid>
        <Grid item size="auto" sx={styles.listHeader}>
        </Grid>
    </Grid>

)

export const getCategoryLight = (c) => {
    const _c = { id: c.id, category_name: c.category_name, category_description: c.category_description, category_number: c.category_number  }
    return _c
}